import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=fd4fbc74&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"
import style0 from "./channel.vue?vue&type=style&index=0&id=fd4fbc74&prod&lang=less&scoped=true&"
import style1 from "./channel.vue?vue&type=style&index=1&id=fd4fbc74&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4fbc74",
  null
  
)

export default component.exports